import { gql } from '@apollo/client'

import { DebitCardTransactionTypeV2 } from 'types/gql-global-types'
import { GetCanUnlinkContactDebitCardTransactionV2Fragment } from 'types/gql-types/GetCanUnlinkContactDebitCardTransactionV2Fragment'
import { GetIsTransferInDebitCardTransactionV2Fragment } from 'types/gql-types/GetIsTransferInDebitCardTransactionV2Fragment'

interface GetCanUnlinkContactArguments {
  transaction: GetCanUnlinkContactDebitCardTransactionV2Fragment
}

interface GetIsTransferInArguments {
  transaction: GetIsTransferInDebitCardTransactionV2Fragment
}

export const getIsTransferIn = ({ transaction }: GetIsTransferInArguments) =>
  [
    DebitCardTransactionTypeV2.DE_IN,
    DebitCardTransactionTypeV2.NPP_IN,
  ].includes(transaction.type)

getIsTransferIn.fragments = {
  DebitCardTransactionV2: gql`
    fragment GetIsTransferInDebitCardTransactionV2Fragment on DebitCardTransactionV2 {
      type
    }
  `,
}

export const getCanUnlinkContact = ({
  transaction,
}: GetCanUnlinkContactArguments) =>
  getIsTransferIn({ transaction }) && !!transaction.contact?.id

getCanUnlinkContact.fragments = {
  DebitCardTransactionV2: gql`
    fragment GetCanUnlinkContactDebitCardTransactionV2Fragment on DebitCardTransactionV2 {
      ...GetIsTransferInDebitCardTransactionV2Fragment

      contact {
        id
      }
    }

    ${getIsTransferIn.fragments.DebitCardTransactionV2}
  `,
}
